// ControlTextFactory.js

import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';
import propertyViewMapService from 'PropertyViewMapService.js';

import ControlModel    from 'ControlModel.js';
import TextControlView  from 'common-visuals/TextControlView.js';


//=============================================================================
//
// Creates one of five kinds of text control, given a factoryService
// parameter key and a layout postion. The factory key defines the 
// control appearance through its template. It defines the  initial rectangle
// of the control via a width and height from the factory parameter.
//
// -Lou Mauget, December 5, 2015
//
//=============================================================================
class ControlTextFactory extends BaseVisualControlFactory {

	constructor () {
		super();
	}

	createView( factoryKey, pos ) {

  		const attributes = this.createChildAttributes( factoryKey, pos ) ;
  		//adding silent(accessibility) to attributes.
  		attributes.silent = false;
		attributes.styleColorText = '~textColor';
		attributes.fontFamily = '~textFont';
		attributes.fontSize = '~textFont';
		attributes.textWeight = '~textFont';
		attributes.textStyle = '~textFont';
		attributes.sharedSettingsTitle = 'Text Shared Settings';
		attributes.tabSettingsTitle = 'Text Settings';
		attributes.inlineEditable = true;
		attributes.maxChars = '';
		attributes.isHtml = false;
		attributes.resizePadding = 2;
		attributes.text = 'Text';
		attributes.minWidth = 10;
		attributes.lowestHeight = 10;
		attributes.translateProps = [
            {key:"text", label:"Text"},
            {key:"toolTip", label:"Tooltip"}
        ];
        this.resolveForInitialMinHeight(attributes);

        const view = new TextControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            							pos: pos, factoryKey: factoryKey,
										id: attributes.id } );

		return view;
	}

}

const controlTextFactory = new ControlTextFactory();

export default controlTextFactory;
